import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { Link, useLocation } from "react-router-dom";

import ModuleSkeleton from "./ModuleSkeleton";
import { Lives } from "../../../DummyData";
import { serverInfo } from "../../../App";
import ReactPlayer from "react-player";

export const RightModule = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const [learningSession, setLearningSession] = useState([]);
  const [greetings, setGreetings] = useState([]);
  const [liveChat, setLiveChat] = useState([]);
  const [qna, setQna] = useState([]);
  const [auditionList, setAuditionList] = useState([]);
  const [meetupPhotos, setMeetupPhotos] = useState([]);
  const [liveNow, setLiveNow] = useState([]);
  const [loadingByffer, setLoadingByffer] = useState(true);

  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/");

  useEffect(() => {
    axios.get("/api/user/all-upcomming-events").then((res) => {
      if (res.status === 200) {
        setLoadingByffer(false);
        setLearningSession(res.data.learningSession);
        setGreetings(res.data.greetings);
        setLiveChat(res.data.LiveChat);
        setQna(res.data.qna);
        setMeetupPhotos(res.data.meetup);
        setAuditionList(res.data.audition);
        setLiveNow(res.data.liveNow);
      }
    });
  }, []);

  return (
    <>
      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">Live Now</div>
            {/* <Link to="/live-now">
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link> */}
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {liveNow.map((event, i) => (
                <Link key={i}>
                  <div className="item px-2 my-1">
                    {event?.video ? (
                        <ReactPlayer
                        url={videoCdnUrl+event?.video}
                        controls={true}
                        autoplay={false}
                        volume={1}
                        height={100}
                        width={150}
                        className="LivePIcM"
                        style={{ margin: "0 auto" }}
                      />
                    ) : (
                      <img
                        src={imageCdnUrl + event?.banner}
                        className="LivePIcM"
                        alt=""
                      />
                    )}
                    <div className="top-right-c">🟢</div>
                    <div className="LivePIcM_t ">Text write</div>
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}
      {/* Greetings */}
      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">
              Greetings
            </div>
            <Link
              to={
                localStorage.getItem("auth_token")
                  ? `/upcoming-greetings`
                  : `/guest_mode/upcoming-greetings`
              }
            >
              {" "}
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link>
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {greetings.map((event, i) => (
                <Link key={i} to={`starprofile/${event?.star_id}/greeting`}>
                  <div className="item px-2 my-1">

                  {event?.video ? (
                     <ReactPlayer
                     url={videoCdnUrl+event?.video}
                     controls={true}
                     autoplay={false}
                     volume={1}
                     height={100}
                     width={150}
                     className="LivePIcM"
                     style={{ margin: "0 auto" }}
                   />
                    ) : (
                      <img
                        src={imageCdnUrl + event?.banner}
                        className="LivePIcM"
                        alt=""
                      />
                    )}
                    
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}
      {/* Learning Session */}
      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">
              Learning Session
            </div>
            <Link
              to={
                localStorage.getItem("auth_token")
                  ? `/upcoming-learning-sessions`
                  : `/guest_mode/upcoming-learning-sessions`
              }
            >
              {" "}
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link>
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {learningSession.map((event, i) => (
                <Link key={i} to={`/learning-session/details/${event.id}`}>
                  <div className="item px-2 my-1">

                  {event?.video ? (
                     <ReactPlayer
                     url={videoCdnUrl+event?.video}
                     controls={true}
                     autoplay={false}
                     volume={1}
                     height={100}
                     width={150}
                     className="LivePIcM"
                     style={{ margin: "0 auto" }}
                   />
                    ) : (
                      <img
                        src={imageCdnUrl + event?.banner}
                        className="LivePIcM"
                        alt=""
                      />
                    )}
                    
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}

      {/*Upcoming Live Chat*/}

      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">Live Chat</div>
            <Link to="/upcoming-live-chat">
              {" "}
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link>
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {liveChat.map((event, i) => (
                <Link key={i} to={`/livechat/details/${event.slug}`}>
                  <div className="item px-2 my-1">
                    <img
                      src={imageCdnUrl + event.banner}
                      className="LivePIcM"
                      alt=""
                    />
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}

      {/*Upcoming Auditions */}
      {/* {loadingByffer ? (
          <ModuleSkeleton />
        ) : (
       <div className="mt-3 LiveMoBG">
         <div className="d-flex MobileMain justify-content-between mx-2">
           <div className="text-warning LeftTeI pt-2 pb-2">
             Upcoming Auditions
           </div>
           <Link to="/upcoming-auditions">
             <div className="text-light LeftTeP btn pt-3">Check More</div>
           </Link>
         </div>


         <div className="">
           <OwlCarousel
             items={2}
             loop
             autoplay
             autoplayTimeout={3000}
             margin={0}
             dots={false}
           >
             {auditionList.map((event, i) => (
               <Link key={i} to={`/audition/registration/${event.slug}`}>
                 <div className="item px-2 my-1">
                   <img
                     src={imageCdnUrl + event.banner}
                     className="LivePIcM"
                     alt=""
                   />
                 </div>
               </Link>
             ))}
           </OwlCarousel>
         </div>
       </div>
     )} */}
      {/*Meetup Events */}
      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">Meetup Events</div>
            <Link to="/upcoming-meetup-events">
              {" "}
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link>
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {meetupPhotos.map((event, i) => (
                <Link key={i} to={`/meetup-event/details/${event.slug}`}>
                  <div className="item px-2 my-1">
                    <img
                      src={imageCdnUrl + event.banner}
                      className="LivePIcM"
                      alt=""
                    />
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}

      {/*Question $ Answer */}
      {loadingByffer ? (
        <ModuleSkeleton />
      ) : (
        <div className="mt-3 LiveMoBG">
          <div className="d-flex MobileMain justify-content-between mx-2">
            <div className="text-warning LeftTeI pt-2 pb-2">
              Question & Answer
            </div>
            <Link to="/upcoming-qna-events">
              {" "}
              <div className="text-light LeftTeP btn pt-3">Check More</div>
            </Link>
          </div>

          <div className="">
            <OwlCarousel
              items={2}
              loop
              autoplay
              autoplayTimeout={3000}
              margin={0}
              dots={false}
            >
              {qna.map((event, i) => (
                <Link key={i} to={`/qna/details/${event.slug}`}>
                  <div className="item px-2 my-1">
                    <img
                      src={imageCdnUrl + event.banner}
                      className="LivePIcM"
                      alt=""
                    />
                  </div>
                </Link>
              ))}
            </OwlCarousel>
          </div>
        </div>
      )}
    </>
  );
}